module.exports = __webpack_public_path__ + "img/banner8.0d5a223d.png";